import * as React from 'react';
import { Box } from '../Box/Box.js';
import { useDirectionContext, Direction } from '../../contexts/session/Locale.js';
import { GroupContext } from './GroupContext.js';

var GroupDivider = function GroupDivider(props) {
  var children = props.children;
  var direction = useDirectionContext();
  var floatingChildren = children &&
  /*#__PURE__*/
  // Push back 1px because of the divider space
  React.createElement(Box, {
    position: "absolute",
    zIndex: 1,
    transform: direction === Direction.RTL ? 'translateX(calc(50% - 1px))' : 'translateX(calc(-50% + 1px))'
  }, children);
  return /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: false
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    p: "2",
    position: "relative"
  }), floatingChildren));
};
var GroupDividerMemoized = /*#__PURE__*/React.memo(GroupDivider);
GroupDividerMemoized.displayName = 'GroupDivider';

export { GroupDividerMemoized as GroupDivider };
//# sourceMappingURL=GroupDivider.js.map
